/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useMemo, useEffect } from 'react';
const DrawerDescList = ({ row, drawer, targetRef, }) => {
    useEffect(() => {
        var _a;
        (_a = targetRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, [targetRef]);
    const drawerColumns = typeof (drawer === null || drawer === void 0 ? void 0 : drawer.columns) === 'function'
        ? drawer === null || drawer === void 0 ? void 0 : drawer.columns(row)
        : drawer === null || drawer === void 0 ? void 0 : drawer.columns;
    const displayedCells = useMemo(() => row.cells.filter(cell => drawerColumns === null || drawerColumns === void 0 ? void 0 : drawerColumns.includes(cell.column.id)), [row.cells, drawerColumns]);
    return (React.createElement("dl", null, displayedCells.map((cell, index) => {
        const { column } = cell;
        return (React.createElement("div", { key: column.id },
            React.createElement("dt", Object.assign({}, (index === 0 ? { ref: targetRef, tabIndex: -1 } : {})), column.render('Header')),
            React.createElement("dd", { "data-private": cell.column.isPrivate }, cell.render('Cell'))));
    })));
};
export { DrawerDescList };
//# sourceMappingURL=DrawerDescList.js.map